<div class="barchart">
  {% for i, bar of bars %}
    <div class="bar{{ i >= left && i <= right ? ' bar--active': '' }}" style="width: {{100 / bars.length | floor}}%; transform: translate3d({{100 * i }}%, {{ 100 - bar | round }}%, 0);"></div>
  {% endfor %}
</div>
